import {doAjax, showAjaxResponseContent} from "../common/_ajax";

export default function (){
    // Bind event handler to document so they are not removed when element markup is regenerated,
    // see http://stackoverflow.com/a/16063194/94289
    $(document).on('change', ':input[data-item-id]', function () {
        const $surveyElementDiv = $(this).closest('.sl-survey-element');
        const itemInput = {
            'itemID': $(this).data('item-id'),
            'itemValue': $(this).val(),
            'pageID': $("input[name='hidden-page-id']").val(),
            'userSurveyID': $("input[name='hidden-user-survey-id']").val(),
            'surveyElementID': $surveyElementDiv.data('survey-element-id')
        };

        const saveUrl = $('#sl-js-save-item-input-url').val();
        const jqXHR = doAjax({url: saveUrl, data: itemInput});
        jqXHR.done(function (data) {
            showAjaxResponseContent(data);
        });
    });
}
